<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" @visibleChange="addCount">
    <div :class="$style.dropdown">
      <a-badge :count="count">
        <a-avatar :src="`${this.$store.state.user.pathAvatar}?tr=w-100/tr:r-max`" shape="circle" size="large" :class="$style.avatar"/>
      </a-badge>
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <router-link :to="{ name: 'accountsProfile'}">
          <div>
            <strong>{{ $t('topBar.profileMenu.hello') }}, {{ user.name || 'Sin nombre' }}</strong>
          </div>
          <div>
            <strong class="mr-1">{{ $t('topBar.profileMenu.role') }}:</strong>
            {{ user.role || '—' }}
          </div>
          <div>
            <strong class="mr-1">{{ $t('topBar.profileMenu.email') }}:</strong>
            {{ user.email || '—' }}
          </div>
        </router-link>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <router-link :to="{ name: 'settingsProfile'}">
          <i class="fe fe-user mr-2"></i>
          {{ $t('topBar.profileMenu.editProfile') }}
        </router-link>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i class="fe fe-log-out mr-2"></i>
          {{ $t('topBar.profileMenu.logout') }}
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user']),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      count: 0,
    }
  },
  methods: {
    addCount() {
      // this.count++
    },
    logout() {
      sessionStorage.clear()
      this.$store.dispatch('user/LOGOUT')
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
